module.exports = __webpack_public_path__ + "static/media/18.60fab643.jpg";